import createIcon from '../../createIcon';

/**
 * @component @name CurtainsClosed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTlWM0g0VjE5SDJWMjFIMjJWMTlIMjBaTTExIDVIMTNWMTlIMTFWNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CurtainsClosed = createIcon('CurtainsClosed', [
  ['path', { d: 'M20 19V3H4V19H2V21H22V19H20ZM11 5H13V19H11V5Z', key: 'p1qho0' }],
]);

export default CurtainsClosed;
